import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFaq = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#faq_svg__a)">
      <path
        fill="#263E6A"
        d="M5.859 11c0-.338.24-.568.532-.568s.533.23.533.568c0 .327-.24.557-.533.557-.292 0-.532-.23-.532-.557m.178-4.705-.02-.837h.748l-.02.837-.102 3.38H6.14zM16.6 11.586c0-.5-.3-.9-.898-.9-.41 0-.78.202-1.069.532l-.44-.4c.392-.44.922-.77 1.597-.77.941 0 1.56.571 1.56 1.485 0 1.223-1.5 1.715-1.348 3.016h-.679c-.198-1.446 1.277-1.979 1.277-2.963m-1.472 4.342c0-.351.25-.591.554-.591s.555.24.555.591c0 .34-.25.58-.554.58s-.555-.24-.555-.58m5.455-8.13H10.8a2.42 2.42 0 0 0-2.417 2.417v2.47h-.821a.364.364 0 0 0-.248.087l-.133.104L5.25 14.4v-1.169c0-.191 0-.548-.366-.548H3.122c-.767 0-1.392-.662-1.392-1.477v-5c0-.814.66-1.477 1.47-1.477h7.568c.81 0 1.47.563 1.47 1.255v.596a.365.365 0 0 0 .73 0v-.596c0-1.095-.986-1.985-2.2-1.985H3.2C1.987 4 1 4.99 1 6.207v5c0 1.218.952 2.208 2.122 2.208H4.52v1.557c0 .19.092.35.248.424a.4.4 0 0 0 .185.043.5.5 0 0 0 .301-.111l2.38-1.88q.023-.015.043-.034h.707v3.058a2.42 2.42 0 0 0 2.417 2.417h.642a.2.2 0 0 1 .062.02l2.37 2.119a.47.47 0 0 0 .314.128.4.4 0 0 0 .17-.037.44.44 0 0 0 .253-.42l.002-1.81h5.97A2.42 2.42 0 0 0 23 16.472v-6.257a2.42 2.42 0 0 0-2.417-2.417m1.687 8.674c0 .93-.757 1.687-1.687 1.687h-6.246l-.093-.047-.167.089c-.194.104-.194.258-.194.492l-.001 1.362-1.891-1.69a.9.9 0 0 0-.543-.207H10.8c-.93 0-1.687-.756-1.687-1.687v-6.256c0-.93.757-1.686 1.687-1.686h9.783c.93 0 1.687.756 1.687 1.686z"
      />
    </g>
    <defs>
      <clipPath id="faq_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFaq;
